module.exports = __webpack_public_path__ + "img/wild_comming.8645ae39.png";